import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the DefaultLoadingPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-default-loading',
  templateUrl: 'default-loading.html',
})
export class DefaultLoadingPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad DefaultLoadingPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/default-loading/default-loading.ts